﻿'use strict';

var centralApp = angular.module('app.components');

centralApp.directive('lerArquivo', lerArquivoFunc);


lerArquivoFunc.$inject = ['$q'];

function lerArquivoFunc($q) {
    var slice = Array.prototype.slice;

    return {
        restrict: 'A',
        require: '?ngModel',
        scope: {
            carregado: '=?' 
        },
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) return;

            ngModel.$render = function () { };

            element.bind('change', function (e) {
                var element = e.target;

                $q.all(_.map(element.files, readFile))
                    .then(function (values) {
                        if (element.multiple) ngModel.$setViewValue(values);
                        else ngModel.$setViewValue(values.length ? values[0] : null);
                    });

                function readFile(file) {

                    if (!scope.carregado) return file;

                    var deferred = $q.defer();

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        deferred.resolve(e.target.result);
                    };
                    reader.onerror = function (e) {
                        deferred.reject(e);
                    };
                    reader.readAsDataURL(file);

                    return deferred.promise;
                }

            });

        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/ler-arquivo/index.js
// module id = 314
// module chunks = 1